export default "/images/battery.svg?c94f6b75caf2b02d5f23ba9d94631bc5";